import * as types from "@/store/types";

const state = {
  buySellState: "buy"
};

const getters = {
  [types.buySellState.getters.GET_BUY_SELL_STATE]: state => {
    return state.buySellState;
  }
};

const mutations = {
  [types.buySellState.mutations.MUTATE_BUY_SELL_STATE]: (state, payload) => {
    state.buySellState = payload;
  }
};

const actions = {
  [types.buySellState.actions.SET_BUY_SELL_STATE]: ({ commit }, payload) => {
    commit(types.buySellState.mutations.MUTATE_BUY_SELL_STATE, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
